import EcoSpace from 'eco-design/base/eco-space';
import styles from './index.module.scss';
import EcoSection from 'eco-design/base/eco-section';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import { useEffect, useRef, useState } from 'react';
import { title } from 'process';
import { useCountUp } from './useCountUp';
import { Navigation, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

const E: React.FC = () => {
    const { t } = useLang('Delta3AirSeries.E');
    const [selectIndex, setSelectIndex] = useState(0);
    const swiperRef = useRef<any>(null);
    const tabItems = [
        {
            tabValue: t('item_tab1'),
            tabLabel: t('item_tab1'),
        },
        { tabValue: t('item_tab2'), tabLabel: t('item_tab2') },
    ];
    // 点击切换
    const onTabChange = (item: EcoTabItemProps, index: number) => {
        if (index === selectIndex) {
            return;
        }
        setSelectIndex(index);
        swiperRef.current?.slideTo(index);
    };
    const item = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1763521757494/Frame%201612708186.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1763521757230/1000.jpg',
            title1: t('item1_title_1'),
            title2: t('item1_title_2'),
            desc1: t('item1_desc_1'),
            desc2: t('item1_desc_2'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1763952460988/Frame%201612708106%20(1).jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1763521757768/2000.jpg',
            title1: t('item2_title_1'),
            title2: t('item2_title_2'),
            desc1: t('item2_desc_1'),
            desc2: t('item2_desc_2'),
        },
    ];
    const { curNumber, run, reset } = useCountUp({ number: item[selectIndex].title1, time: 400 });
    const { curNumber: curNumber2, run: run2, reset: reset2 } = useCountUp({ number: item[selectIndex].title2, time: 400 });
    useEffect(() => {
        run();
        run2();
    }, [selectIndex]);
    return (
        <section className={`${styles.E} GtmModuleData-section range2`} id="List-sence-B" data-section-id="D3A-E">
            <EcoSpace />
            <div className="E-content">
                <EcoSection title={t('title')} desc={t('desc')} />

                <div className="E-box">
                    <div className="item-img-box">
                        {/* {selectIndex === 0 && }
                        {selectIndex === 1 && <EcoImg className="item-img" pc={item[1].pc} pad={item[1].pad} isOpenLazy></EcoImg>} */}
                        <Swiper
                            modules={[Navigation, EffectFade]}
                            onSwiper={(swiper) => (swiperRef.current = swiper)}
                            effect={'fade'}
                            speed={600}
                            centeredSlides={true}
                            slidesPerView={'auto'}
                            allowTouchMove={false} // 🚫 禁止触摸滑动
                            simulateTouch={false} // 🚫 禁止鼠标拖动
                            keyboard={{ enabled: false }} // 🚫 禁止键盘操作
                            mousewheel={false} // 🚫 禁止滚轮操作
                        >
                            {item.map((item: any, index: number) => (
                                <SwiperSlide key={index} className="swiper-slide">
                                    <EcoImg className="item-img" pc={item.pc} pad={item.pad} ></EcoImg>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>

                    <div className="E-text">
                        <div className="E-text-item">
                            <div className="title">
                                {curNumber.split('').map((i, idx) => (
                                    <div key={idx}>{i}</div>
                                ))}
                                W
                            </div>
                            <p className="desc">{item[selectIndex].desc1}</p>
                        </div>
                        <div className="E-text-item">
                            <div className="title">
                                {curNumber2.split('').map((i, idx) => (
                                    <div key={idx}>{i}</div>
                                ))}
                                W
                            </div>
                            <p className="desc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="73" height="16" viewBox="0 0 73 16" fill="none">
                                    <g clip-path="url(#clip0_8059_920)">
                                        <path
                                            d="M42.3929 2.04297H37.4445C36.4765 2.04297 35.4806 2.82822 35.2203 3.79772L34.1383 7.83509C33.8794 8.80313 34.4541 9.58984 35.4236 9.58984H40.3706C41.3401 9.58984 42.3359 8.80313 42.5962 7.83509L43.6768 3.79772C43.9371 2.82822 43.3624 2.04297 42.3929 2.04297ZM41.0988 7.72396C41.0491 7.89003 40.9004 8.00704 40.7273 8.01641H35.9091C35.836 8.0209 35.7655 7.9878 35.7223 7.9286C35.6791 7.8694 35.669 7.79227 35.6956 7.72396L36.7192 3.90592C36.7687 3.74033 36.9166 3.62344 37.0892 3.61347H41.9147C41.9876 3.60976 42.0575 3.64305 42.1005 3.702C42.1435 3.76095 42.1539 3.83762 42.1282 3.90592L41.0988 7.72396Z"
                                            fill="black"
                                        />
                                        <path
                                            d="M52.1408 2.04297H47.1924C46.2243 2.04297 45.2285 2.82822 44.9682 3.79772L43.8861 7.83509C43.6273 8.80313 44.202 9.58984 45.1715 9.58984H50.1184C51.0879 9.58984 52.0837 8.80313 52.344 7.83509L53.4246 3.79772C53.6849 2.82822 53.1103 2.04297 52.1408 2.04297ZM50.8466 7.72396C50.7969 7.89003 50.6483 8.00704 50.4752 8.01641H45.6497C45.5765 8.0209 45.5061 7.9878 45.4629 7.9286C45.4197 7.8694 45.4096 7.79227 45.4362 7.72396L46.4598 3.90592C46.5093 3.74033 46.6572 3.62344 46.8297 3.61347H51.6553C51.7282 3.60976 51.798 3.64305 51.8411 3.702C51.8841 3.76095 51.8945 3.83762 51.8688 3.90592L50.8466 7.72396Z"
                                            fill="black"
                                        />
                                        <path
                                            d="M33.134 2.04297H26.1355L25.7143 3.61493H32.65L32.2712 5.0275H25.3385L24.116 9.58837H31.1146C31.9217 9.58837 32.7523 8.93327 32.9687 8.12609L33.2744 6.9855C33.4469 6.33917 33.0638 5.81567 32.4174 5.81567C33.0638 5.81567 33.7335 5.29071 33.9017 4.64584L34.2073 3.50672C34.4208 2.69661 33.9412 2.04297 33.134 2.04297ZM31.4684 8.01495H26.058L26.4367 6.60238H31.8472L31.4684 8.01495Z"
                                            fill="black"
                                        />
                                        <path
                                            d="M55.7148 5.03042L56.0965 3.60907H63.0204L63.4415 2.04297H56.4533C55.6446 2.04297 54.8155 2.69661 54.5991 3.50526L53.77 6.59946H60.6954L60.3137 8.02227H53.3883L52.976 9.58837H59.9642C60.7714 9.58837 61.602 8.93327 61.8184 8.12609L62.6475 5.03042H55.7148Z"
                                            fill="black"
                                        />
                                        <path
                                            d="M73.0049 2.03906H64.5353L64.1156 3.6081H67.5856L65.983 9.58447H67.5125L69.1137 3.6081H72.5837L73.0049 2.03906Z"
                                            fill="black"
                                        />
                                        <path d="M19.1653 6.59638H23.3869L23.8066 5.02734H19.5865L19.1653 6.59638Z" fill="black" />
                                        <path d="M10.2931 0H6.03641L9.75353 5.03028L12.4705 2.94212L10.2931 0Z" fill="black" />
                                        <path d="M14.6331 11.6267H18.8898L15.4783 7.01172L12.5421 8.80009L14.6331 11.6267Z" fill="black" />
                                        <path
                                            d="M22.7885 0H17.4424L8.19484 7.09503H10.2201L0.000183105 15.6626L17.5067 5.02881H15.4668L22.7885 0Z"
                                            fill="url(#paint0_linear_8059_920)"
                                        />
                                    </g>
                                    <defs>
                                        <linearGradient
                                            id="paint0_linear_8059_920"
                                            x1="21.5281"
                                            y1="-1.00001e-07"
                                            x2="0.032845"
                                            y2="15.6452"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stop-color="#EAC64C" />
                                            <stop offset="0.554786" stop-color="#C09325" />
                                            <stop offset="1" stop-color="#AF7D14" />
                                        </linearGradient>
                                        <clipPath id="clip0_8059_920">
                                            <rect width="73.0049" height="15.6626" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </p>
                        </div>
                    </div>
                    <EcoTab items={tabItems} type="round" className={`E-tab`} activeIndex={selectIndex} onChange={onTabChange} />
                </div>
            </div>
            <EcoSpace />
        </section>
    );
};
export default E;
